<template>
  <div class="grid-container" v-bind:class="spacingCssClass">
    <div class="grid-x grid-margin-x o-columns__one">
      <div class="cell">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      spacing: {
        required: false,
        type: String,
      }
    },
    computed: {
      spacingCssClass() {
        return this.spacing !== undefined ? `u-spacing--${this.spacing}` : '';
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/report-a-problem/_vue/ComponentWrapper.vue